import React, { FC, useEffect, useState } from 'react';

import { RightOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Menu, Row, notification } from 'antd';
import classnames from 'classnames';
import { config } from 'config/config';
import routePaths, { staticRoutes } from 'config/routes';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { logout } from 'src/actions/authActions';
import NotificationDot from 'src/components/general/NotificationDot';
import { openToast } from 'src/components/general/Toast';
import { getItemLink } from 'src/components/layout/BasicMenu';
import Link from 'src/components/Link';
import { IRootReducers } from 'src/reducers';
import {
  UserAccountStatusEnum,
  UserStatusEnum,
} from 'src/shared/enums/user.enum';
import { IMenu } from 'src/shared/models';
import {
  defaultLanguage,
  getCookiesFromClient,
  getTranslatedData,
  isConPlatform,
  removeCookieFromClient,
  requestOrderStatus,
  getUserData,
} from 'utils';

const {
  ACCOUNT_NOT_VALIDATED,
  MANAGER_NOT_VALIDATED,
  NO_CENTER,
  HCP_NOT_VALIDATED,
  STAFF_NOT_VALIDATED,
} = UserStatusEnum;

const { COOKIES_POLICY, PRIVACY_POLICY, TERMS } = staticRoutes.FOOTER;
const { CONTACT_US } = routePaths.FOOTER;
const { LOGIN, SIGNUP, MY_ACCOUNT, CONTACT_REP } = routePaths.PAGES;
const { BASE_URL } = config.APP;
const { TOAST_COOKIE } = config.COOKIES;

const DEFAULT_MENU_ITEMS: AccountSubmenuItem[] = [
  {
    id: 1,
    name: 'menu.section.personal.points',
    link: MY_ACCOUNT.MY_POINTS,
    icon: 'points',
  },
  {
    id: 7,
    name: 'menu.section.personal.coupons',
    link: MY_ACCOUNT.MY_BONUS,
    icon: 'ticket',
  },
  {
    id: 2,
    name: 'menu.section.personal.profile',
    link: MY_ACCOUNT.MY_PROFILE,
    icon: 'user',
  },
  {
    id: 5,
    name: 'menu.section.personal.addresses',
    link: MY_ACCOUNT.MY_ADDRESSES,
    icon: 'home',
  },
];

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators({ logout }, dispatch);

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  OwnProps;

interface OwnProps {
  cartItems: number;
  loggedMenu: IMenu[];
}

interface AccountSubmenuItem {
  id: number;
  name: string;
  link: string;
  icon: string;
}

const DrawerMenu: FC<Props> = ({
  cartItems,
  impersonate,
  loggedMenu,
  logout,
  user,
  userPoints,
  userStatus,
  dermo,
}): JSX.Element => {
  const { formatMessage } = useIntl();
  const router = useRouter();
  const { asPath, pathname } = router;
  const { publicRuntimeConfig } = getConfig();
  const cleanRoute = asPath.replace(publicRuntimeConfig.PLATFORM_PREFIX, '');
  const replacedAsPath = cleanRoute.replace(pathname, '');
  const userData = getUserData(user);

  const [collapsed, setCollapse] = useState(false);
  const [accountCollapsed, setAccountCollapsed] = useState(true);
  const [updateUserPoints, setUpdateUserPoints] = useState(false);
  const [accountMenuItems, setAccountMenuItems] = useState<
    AccountSubmenuItem[]
  >([]);
  const newUserPoints = getCookiesFromClient(TOAST_COOKIE);

  const getAccountMenuItems = async () => {
    try {
      if (dermo?.dermoStatus === UserAccountStatusEnum.GRANT) {
        setAccountMenuItems([
          ...DEFAULT_MENU_ITEMS,
          {
            id: 6,
            name: 'menu.section.personal.academic-record',
            link: MY_ACCOUNT.MY_ACADEMIC_RECORD,
            icon: 'academic_record',
          },
        ]);
      } else {
        setAccountMenuItems(DEFAULT_MENU_ITEMS);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!accountMenuItems.some((item) => item.id === 6)) getAccountMenuItems();
  }, [user]);

  useEffect(() => {
    if (newUserPoints) {
      setUpdateUserPoints(true);
      // openNotification(newUserPoints);
    }
  }, [newUserPoints]);

  useEffect(() => {
    if (updateUserPoints) {
      removeCookieFromClient(TOAST_COOKIE);
      setTimeout(() => {
        setUpdateUserPoints(false);
      }, 6000);
    }
  }, [updateUserPoints]);

  const openNotification = (scanPoints: string) => {
    openToast(
      formatMessage(
        { id: 'notification.points.success' },
        { points: Number(scanPoints).toLocaleString() },
      ),
      'success',
      6,
      'puntos',
      'increase_50',
    );
  };

  const handleCollapse = (): void => {
    setAccountCollapsed(true);
    setCollapse(!collapsed);
  };

  const countryList = (
    <Menu>
      <Menu.Item>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.PORTUGAL}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.portugal' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.ITALIA}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.italia' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.FRANCE}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.france' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.BELGIQUE}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.belgique' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.BELGIE}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.belgie' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.DEUTSCHLAND}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.deutschland' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.EMIRATES}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.emirates' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.UNITEDKINGDOM}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.unitedKingdom' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.MEXICO}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.mexico' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.BRASIL}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.brasil' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.ARGENTINA}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.argentina' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.CHILE}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.chile' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.PERU}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.peru' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.COLOMBIA}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.colombia' })}
        </a>
        <a
          href={`${config.CON.LANDING.BASE_URL}${config.CON.COUNTRY.UNITEDSTATES}${replacedAsPath}`}>
          {formatMessage({ id: 'menu.dropdown.country.unitedStates' })}
        </a>
      </Menu.Item>
    </Menu>
  );

  const appBar = (): JSX.Element => (
    <>
      <Col className="basicHeader__menu" span={6}>
        {isConPlatform && !user ? null : (
          <Row justify="start" align="middle">
            <Button
              className="basicHeader__menu__button"
              onClick={handleCollapse}
              type="link">
              <div className="icon icon--menu" />
              <NotificationDot position="icon" />
            </Button>
          </Row>
        )}
      </Col>
      <Col span={12}>
        <Row justify="center" align="middle">
          <Link href="/">
            <img
              alt="logo"
              loading="lazy"
              className="logo"
              src={
                isConPlatform
                  ? `${config.APP.ASSET_PREFIX}/isdin_logo_mobile.png`
                  : `${config.APP.ASSET_PREFIX}/isdin_logo.png`
              }
              onClick={() => setCollapse(false)}
            />
          </Link>
        </Row>
      </Col>
      <Col span={6}>
        <Row justify="end" align="middle">
          {user ? (
            <>
              {isConPlatform ? (
                <Link href={MY_ACCOUNT.MY_POINTS}>
                  <a className="link basicHeader__signin__icon--container">
                    <span
                      className={`basicHeader__signin__icon--points-text ${
                        updateUserPoints && 'addPoints'
                      }`}>
                      {
                        /* 'es-ES' locale does not provide formatting with thousands separators */
                        new Intl.NumberFormat('de-DE').format(userPoints)
                      }
                    </span>
                    <span
                      className={`icon icon--puntos ${
                        updateUserPoints && 'icon__success'
                      }`}
                    />
                  </a>
                </Link>
              ) : (
                <Link href={BASE_URL}>
                  <a className="link basicHeader__signin__icon--container">
                    <span className="basicHeader__signin__icon basicHeader__signin__icon--bag" />
                    {cartItems}
                  </a>
                </Link>
              )}
            </>
          ) : null}
        </Row>
      </Col>
    </>
  );

  const buildUserAction = (
    goto: string,
    label: string,
    showBorder: boolean,
  ): JSX.Element => {
    const classBorder = showBorder ? 'container-label__with-border' : '';

    return (
      !user && (
        <Link href={goto}>
          <Col span={12} onClick={handleCollapse}>
            <Row
              align="middle"
              className={`container-label ${classBorder}`}
              justify="center">
              <span className="container-text">
                <FormattedMessage id={label} />
              </span>
            </Row>
          </Col>
        </Link>
      )
    );
  };

  const buildFooterLinkSpecial = (goto: string, label: string): JSX.Element => {
    return (
      <Link href={`/static?page=${goto}`} as={goto} replace>
        <Row className="link-to-static-pages" onClick={handleCollapse}>
          <FormattedMessage id={label} />
        </Row>
      </Link>
    );
  };

  const buildFooterLink = (goto: string, label: string): JSX.Element => {
    return (
      <Link href={goto}>
        <Row className="link-to-static-pages" onClick={handleCollapse}>
          <FormattedMessage id={label} />
        </Row>
      </Link>
    );
  };

  const welcomeMessage = !user && (
    <Row className="welcome-message">
      <h2>
        <FormattedMessage id="app.welcome" />
      </h2>
      <Row className="regular-body" style={{ paddingBottom: '1cm' }}>
        <FormattedMessage id="app.welcome-description-create-account" />
      </Row>
      <Row className="regular-body">
        <FormattedMessage id="app.welcome-description-sign-in" />
      </Row>
    </Row>
  );

  const renderMenuItems = (): JSX.Element[] =>
    loggedMenu
      ?.sort((a: IMenu, b: IMenu) => a.order - b.order)
      .map((item: IMenu): JSX.Element => {
        if (!item.visible) return;

        const disabled =
          item.route === routePaths.PAGES.REQUEST_ORDER &&
          !requestOrderStatus.includes(userStatus)
            ? true
            : item.disabled || false;

        const _buttonDetails = (
          <Row
            className={`logged-menu-button ${disabled ? 'disabled' : ''}`}
            onClick={handleCollapse}
            justify="space-between"
            align="middle">
            {getTranslatedData(item, 'content', defaultLanguage) || item.name}
            <RightOutlined />
          </Row>
        );

        return item.absolute ? (
          <a
            key={item.idMenu}
            href={item.route}
            className={item.disabled ? 'disabled' : ''}>
            {_buttonDetails}
          </a>
        ) : (
          <Link href={getItemLink(item.route)} key={item.route || item.idMenu}>
            {_buttonDetails}
          </Link>
        );
      });

  const handleLogout = async () => {
    try {
      const currentPath = pathname;
      await logout();

      openToast(formatMessage({ id: 'app.logout' }), 'success', 5);

      if (currentPath === routePaths.INDEX) {
        router.reload();
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        notification['error']({
          message: formatMessage({ id: 'app.logout-error' }),
          description: `${data.code} ${data.error}`,
        });
      }
      console.error(error);
    }
  };

  const toggleAccountCollapsed = () => {
    setAccountCollapsed(!accountCollapsed);
  };

  const myAccountMenu = (): JSX.Element =>
    user && (
      <>
        <Row
          onClick={toggleAccountCollapsed}
          justify="space-between"
          align="top"
          className="logged-menu-button">
          <Col>
            <span className="logged-menu-button-title">
              <span className="logged-menu-button__notification-container">
                <FormattedMessage
                  id="page.account.my-account-header-greeting-{name}"
                  values={{ name: userData.name }}
                />
                <NotificationDot position="lateral-menu" />
              </span>
            </span>
            <Row
              className="logged-menu-button-subtitle"
              justify="start"
              align="middle">
              <div className="icon icon--points" />
              <FormattedMessage
                id="menu.section.personal.{points}-point"
                values={{ points: Number(userPoints).toLocaleString() }}
              />
            </Row>
          </Col>
          {accountCollapsed ? (
            <DownOutlined className="logged-menu-button-icon--collapse" />
          ) : (
            <UpOutlined className="logged-menu-button-icon--collapse" />
          )}
        </Row>
        {!accountCollapsed && (
          <Row className="account-submenu" onClick={handleCollapse}>
            <Col span={24}>
              <Link href={MY_ACCOUNT.ACCOUNT_INDEX}>
                <Row className="account-submenu-link account-submenu-link--left">
                  <FormattedMessage id="app.my-account" />
                </Row>
              </Link>
              <ul className="account-submenu-list">
                {accountMenuItems.map((item) => (
                  <li key={item.id}>
                    <Link href={item.link}>
                      <Row align="middle" justify="start">
                        <div className={`icon icon--${item.icon}`} />
                        <FormattedMessage id={item.name} />
                      </Row>
                    </Link>
                  </li>
                ))}
              </ul>
              <Row
                className="account-submenu-link account-submenu-link--right"
                onClick={handleLogout}>
                <FormattedMessage id="menu.header.logout" />
              </Row>
            </Col>
          </Row>
        )}
      </>
    );

  const drawerClassName: string = classnames('drawer-menu', {
    'drawer-menu__low':
      impersonate ||
      [
        ACCOUNT_NOT_VALIDATED,
        MANAGER_NOT_VALIDATED,
        NO_CENTER,
        HCP_NOT_VALIDATED,
        STAFF_NOT_VALIDATED,
      ].includes(userStatus),
    'drawer-menu__con': isConPlatform,
  });

  const footer = (
    <>
      {isConPlatform ? (
        <div>
          {buildFooterLink(CONTACT_US, 'menu.section.contact.con')}
          {buildFooterLinkSpecial(TERMS, 'app.terms')}
          {buildFooterLinkSpecial(PRIVACY_POLICY, 'app.privacy-policy')}
          {buildFooterLinkSpecial(COOKIES_POLICY, 'app.cookies-policy')}
        </div>
      ) : (
        <>
          {user && buildFooterLink(CONTACT_REP, 'menu.header.contact')}
          {buildFooterLink(CONTACT_US, 'menu.section.contact')}
          {buildFooterLinkSpecial(TERMS, 'app.terms')}
          {buildFooterLinkSpecial(PRIVACY_POLICY, 'app.privacy-policy')}
        </>
      )}
    </>
  );

  return (
    <>
      {appBar()}

      <Drawer
        className={drawerClassName}
        placement="left"
        closable={false}
        visible={collapsed}
        destroyOnClose
        onClose={handleCollapse}
        maskClosable
        zIndex={50000}>
        <div className="drawer-body">
          {welcomeMessage}
          {renderMenuItems()}
        </div>

        <div
          className={`drawer-footer ${
            impersonate ? 'drawer-footer__impersonate' : ''
          }`}>
          <Row className="container-user-actions" align="middle">
            {buildUserAction(LOGIN, 'app.sign-in', true)}
            {buildUserAction(SIGNUP, 'app.register', false)}
            {myAccountMenu()}
          </Row>
          {footer}
        </div>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    user: state.auth.user,
    userStatus: state.auth.userStatus,
    impersonate: state.auth.impersonate,
    userPoints: state.auth.userPoints,
    dermo: state.auth.user?.dermo,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawerMenu);
